/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for UserResource controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_FORMATIONAPI, CLIENT_CONTEXT_TOKEN_FORMATIONAPI } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { UserDTO, RequestOptions, User } from "../models";

@Injectable({ providedIn: "root" })
export class UserResourceService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_FORMATIONAPI);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_FORMATIONAPI;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'formationApi');
    }

    addorUpdateUtilisateur(userDTO: UserDTO, observe?: 'body', options?: RequestOptions<'blob'>): Observable<UserDTO>;
    addorUpdateUtilisateur(userDTO: UserDTO, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<UserDTO>>;
    addorUpdateUtilisateur(userDTO: UserDTO, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<UserDTO>>;
    addorUpdateUtilisateur(userDTO: UserDTO, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/api/addorUpdateUtilisateur`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('post', url, {
            body: userDTO,
            observe,
            headers,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getAll(observe?: 'body', options?: RequestOptions<'json'>): Observable<Array<User>>;
    getAll(observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<Array<User>>>;
    getAll(observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<Array<User>>>;
    getAll(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/api/users`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getUser(login: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<User>;
    getUser(login: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<User>>;
    getUser(login: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<User>>;
    getUser(login: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/api/users/${login}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getUtilisateurs(observe?: 'body', options?: RequestOptions<'json'>): Observable<Array<UserDTO>>;
    getUtilisateurs(observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<Array<UserDTO>>>;
    getUtilisateurs(observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<Array<UserDTO>>>;
    getUtilisateurs(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/api/list-utilisateurs-admin`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getUserById(idUtilisateur?: number, observe?: 'body', options?: RequestOptions<'blob'>): Observable<UserDTO>;
    getUserById(idUtilisateur?: number, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<UserDTO>>;
    getUserById(idUtilisateur?: number, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<UserDTO>>;
    getUserById(idUtilisateur?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/api/utilisateur`;

        let params = new HttpParams();
        if (idUtilisateur != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idUtilisateur, 'idUtilisateur');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getUserById1(idUtilisateur?: number, observe?: 'body', options?: RequestOptions<'blob'>): Observable<UserDTO>;
    getUserById1(idUtilisateur?: number, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<UserDTO>>;
    getUserById1(idUtilisateur?: number, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<UserDTO>>;
    getUserById1(idUtilisateur?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/api/utilisateur`;

        let params = new HttpParams();
        if (idUtilisateur != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idUtilisateur, 'idUtilisateur');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('post', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getUserById2(idUtilisateur?: number, observe?: 'body', options?: RequestOptions<'blob'>): Observable<UserDTO>;
    getUserById2(idUtilisateur?: number, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<UserDTO>>;
    getUserById2(idUtilisateur?: number, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<UserDTO>>;
    getUserById2(idUtilisateur?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/api/utilisateur`;

        let params = new HttpParams();
        if (idUtilisateur != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idUtilisateur, 'idUtilisateur');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('put', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getUserById4(idUtilisateur?: number, observe?: 'body', options?: RequestOptions<'blob'>): Observable<UserDTO>;
    getUserById4(idUtilisateur?: number, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<UserDTO>>;
    getUserById4(idUtilisateur?: number, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<UserDTO>>;
    getUserById4(idUtilisateur?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/api/utilisateur`;

        let params = new HttpParams();
        if (idUtilisateur != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idUtilisateur, 'idUtilisateur');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('patch', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getUserById3(idUtilisateur?: number, observe?: 'body', options?: RequestOptions<'blob'>): Observable<UserDTO>;
    getUserById3(idUtilisateur?: number, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<UserDTO>>;
    getUserById3(idUtilisateur?: number, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<UserDTO>>;
    getUserById3(idUtilisateur?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/api/utilisateur`;

        let params = new HttpParams();
        if (idUtilisateur != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idUtilisateur, 'idUtilisateur');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('delete', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getUserById6(idUtilisateur?: number, observe?: 'body', options?: RequestOptions<'blob'>): Observable<UserDTO>;
    getUserById6(idUtilisateur?: number, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<UserDTO>>;
    getUserById6(idUtilisateur?: number, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<UserDTO>>;
    getUserById6(idUtilisateur?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/api/utilisateur`;

        let params = new HttpParams();
        if (idUtilisateur != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idUtilisateur, 'idUtilisateur');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('options', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getUserById5(idUtilisateur?: number, observe?: 'body', options?: RequestOptions<'blob'>): Observable<UserDTO>;
    getUserById5(idUtilisateur?: number, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<UserDTO>>;
    getUserById5(idUtilisateur?: number, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<UserDTO>>;
    getUserById5(idUtilisateur?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/api/utilisateur`;

        let params = new HttpParams();
        if (idUtilisateur != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idUtilisateur, 'idUtilisateur');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('head', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }
}
